import { GUI } from "dat.gui";
import { Mesh, MeshStandardMaterial, BoxGeometry } from "three";
// import { gsap } from "gsap";

export class Cube extends Mesh {
	constructor(size, { x, y, z }, scale = 1, color = 0x99ff33) {
		super();
		this.geometry = new BoxGeometry(size, size, size);
		const uploadMaterial = new MeshStandardMaterial({
			color: color,
		});
		this.material = uploadMaterial;
		this.name = `cube-${size}`;
		this.position.x = x;
		this.position.y = y;
		this.position.z = z;
		this.renderOrder = 0;
		this.scale.set(scale, scale, scale);
		// this.helpers();
	}
	entryAnimation() {
		// gsap.to(this.position, { y: this.axisY, duration: 0.8 });
	}
	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder(this.name);
		premiaFolder.add(this.position, "x", -30, 30).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -30, 30).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -30, 30).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("Rotacion X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("Rotacion Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("Rotacion Z");
		premiaFolder.add(this.scale, "x", 0, 4).step(0.01).name("Escala X");
		premiaFolder.add(this.scale, "y", 0, 4).step(0.01).name("Escala Y");
		premiaFolder.add(this.scale, "z", 0, 4).step(0.01).name("Escala Z");
	}
}
